var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "preview-sp",
    { staticClass: "pega-sp-print-area" },
    [
      _c("company-preview-detail-sp", {
        attrs: {
          "is-light-plan": _vm.isLightPlan,
          "company-info": _vm.companyInfo,
          report: _vm.report,
          environment: _vm.environment,
        },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "margin-1" }, [
        _c("small", [
          _vm._v(
            "\n      これ以降は、女の転職typeのユーザー画面では表示されません。ただし、提携サイトには表示される場合がございます。あらかじめご了承ください。\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("company-supplement-preview", {
        staticClass: "margin-1 pega-table-sp",
        attrs: { "company-supplement-info": _vm.companySupplementInfo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }